







import CheckBox from '@/views/atoms/CheckBox.vue'

export default
  components: {
    CheckBox
  }

  data: () ->
    value: ''

  props:
    list:
      type: Array
      default: [],
    workingStyleList:
      type: Array
      default: []

  methods: {
    change: (v) ->
      @value = v

    checked: (bool) ->
      @$emit('change', bool, @value)

    defaultCheck: (v) ->
      for val, i in @workingStyleList
        if Number(val.working_style_id) == v.id
          return true
      return false
      

  }
